import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Meta, Title } from 'react-head'
import { withRouter, Link } from 'react-router-dom'
import DefaultLayout from '../../components/DefaultLayout'
import Footer from '../../components/Footer/Footer'
import SubPageHeader from '../../components/SubPageHeader'
import { titleCase } from '../../utils'
import { getBlogPostsByPage, getAuthorFromPost } from '../../wpapi'
import Author from '../../components/Author'
import Excerpt from './_BlogExcerpt'
import ErrorPage from '../../pages/ErrorPage'
import withSSR from 'js/components/withSSR/withSSR'

function BlogCategoryPageContainer({ data, isLoading, error, match, refetch }) {
  useEffect(() => {
    refetch()
  }, [match.url])

  if (isLoading) {
    return <SubPageHeader loading={true} magenta={true} blog={true} />
  }

  if (error || data.code === 'rest_post_invalid_page_number') {
    return <ErrorPage></ErrorPage>
  }

  return (
    <BlogCategoryPage
      posts={data}
      category={match.params.category}
      tag={match.params.tag}
      author={match.params.author}
      authorObject={getAuthorFromPost(data[0])}
      pageNumber={parseInt(match.params.pageNumber, 10) || 1}
      refetch={refetch}
      match={match}
    ></BlogCategoryPage>
  )
}

BlogCategoryPageContainer.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  refetch: PropTypes.func,
  match: PropTypes.object,
}

class BlogCategoryPage extends React.Component {
  static propTypes = {
    posts: PropTypes.object,
    category: PropTypes.string,
    pageNumber: PropTypes.number,
    author: PropTypes.string,
    tag: PropTypes.string,
    authorObject: PropTypes.object,
    match: PropTypes.object,
  }
  constructor(props) {
    super(props)

    this.state = {
      posts: this.props.posts,
      invalidPageNumber: false,
    }
  }

  componentDidMount() {
    this.checkIfThereIsANextPage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.posts !== this.props.posts) {
      this.setState({ posts: this.props.posts })
    }
  }

  apiCall = () => {
    if (this.props.category)
      return getBlogPostsByPage(
        this.props.pageNumber + 1,
        'category_name',
        this.props.category
      )
    if (this.props.author) {
      return getBlogPostsByPage(
        this.props.pageNumber + 1,
        'author',
        this.props.author
      )
    }
    if (this.props.tag) {
      return getBlogPostsByPage(
        this.props.pageNumber + 1,
        'tag',
        this.props.tag
      )
    }
  }

  checkIfThereIsANextPage = () => {
    this.apiCall()
      .then(data => {
        this.setState({
          nextPageAvailable: data.code ? false : true,
        })
      })
      .catch(() => {
        this.setState({
          nextPageAvailable: false,
        })
      })
  }

  formatHeading = () => {
    if (this.props.category) return titleCase(this.props.category)
    if (this.props.tag) return `#${this.props.tag}`
    if (this.props.author) return this.props.authorObject.name
  }

  render = () => (
    <DefaultLayout>
      <Title>Blog - Lifesum</Title>
      <Meta
        name="description"
        content={
          'All about healthy living. Tips on what to cook, which exercises to try, well-researched health articles and more!'
        }
      />
      <SubPageHeader
        heading={this.formatHeading()}
        magenta={true}
        blog={true}
      />
      {this.props.author && (
        <Author author={this.props.authorObject} onAuthorPage={true} />
      )}
      <div className="c-content-area  o-width-limiter">
        <div className="o-grid o-grid--airy o-grid--center">
          {this.state.posts &&
            this.state.posts.map((post, index) => {
              return (
                <div
                  className="o-grid__column"
                  data-size="sm:24 md:12"
                  key={index}
                >
                  <Excerpt post={post} author={this.props.authorObject} />
                </div>
              )
            })}
        </div>
      </div>
      <div className="s-text  o-width-limiter">
        <div className="c-paging c-paging--nudged-up">
          {this.props.pageNumber !== 1 && (
            <Link
              to={
                this.props.match.url.replace(/\/page\/\d{1,}.*/, ``) +
                `/page/${this.props.pageNumber - 1}`
              }
              className="c-paging__prev"
              onClick={this.getNewPosts}
              rel="prev"
            >
              Previous page
            </Link>
          )}
          {this.state.nextPageAvailable && (
            <Link
              to={
                this.props.match.url
                  .replace(/\/page\/\d{1,}.*/, ``)
                  .replace(/\/$/, '') + `/page/${this.props.pageNumber + 1}`
              }
              className="c-paging__next"
              rel="next"
            >
              Next page
            </Link>
          )}
        </div>
      </div>
      <Footer />
    </DefaultLayout>
  )
}

export default withRouter(withSSR(BlogCategoryPageContainer))
